export const ORDER_SELECTION_CARD = 'ORDER_SELECTION_CARD'
